import Vue from 'vue'
import ga from '@/services/ga/google-analytics'
import identities from '@/services/identity'
import utils from '@/services/utils'
import * as FileSaver from 'file-saver-fixed';

let settings = {
    endpoint: window.endpoint_events
};

function postEvent(identityId, identityType, organizationId, category, action, details = {}) {
    let data = {
        'identity_id': identityId,
        'identity_type': identityType,
        'org_id': organizationId,
        'category': category,
        'action': action,
        'details': details
    };

    return Vue.http.post(settings.endpoint + '/events', data).promise;
}

async function send(category, action, details = {}) {
    debugLog(action, details)

    if (identities.hasBecome()) {
        return Promise.resolve()
    }

    const identity = await getCurrentIdentity(identities)
    const payload = getIdentityPayload(identity)

    return postEvent(payload.id, payload.type, payload.organizationId, category, action, details);
}

function debugLog(action, details) {
    if (window.localStorage.getItem('showHiddenEvents')) {
        console.log('[Hidden event log]', action, details);
    }
}

async function getCurrentIdentity(identities) {
    try {
        return await identities.getCurrent();
    } catch (e) {
        console.error('No user identity found', e);
        return false;
    }
}

function getIdentityPayload(identity) {
    return {
        id: identity.id || null,
        type: identity.type || null,
        organizationId: (identity
            && identity.organization
            && identity.organization.data
            && identity.organization.data.id
        ) || null
    }
}

function sendSuperadmin(category, action, details = {}) {
    if (window.localStorage.getItem('showHiddenEvents')) {
        console.log('[Hidden event log @ Superadmin]', action);
    }

    return identities.getCurrent().then(identity => {
        const identityId = identity.id;
        const identityType = identity.type;
        const organizationId = identity.organization.data.id;

        return postEvent(identityId, identityType, organizationId, category, action, details);
    }).catch(error => {
        console.error(error);
    });
}

function downloadCSV(title, events) {
    let header = ['id', 'created_at', 'identity id', 'identity_type', 'organization id', 'category', 'action', 'details'];
    let rows = events.map(event => {
        return [
            event.id,
            event.created_at,
            event.identity_id,
            event.identity_type,
            event.org_id,
            event.category,
            event.action,
            event.details
        ].map(item => {
            return '"' + item.toString().replace('"', '\"') + '"'
        });
    });
    rows.splice(0, 0, header); // Insert header as first row

    let content = rows.join("\n");
    let blob = new Blob([content], {
        type: "application/csv;charset=charset=utf-8"
    });
    FileSaver.saveAs(blob, title + ".csv");
}

function trackSuperadminRedirects(redirectedPath) {
    if (!window.superadmin) return;

    const links = JSON.parse(localStorage.getItem('links')) || {}
    const section = Object.values(links).filter(link => link.url === redirectedPath)[0];

    if (section) {
        sendSuperadmin('Superadmin',`Superadmin section - ${section.label} - opened`)
    }
}

async function handleEventBeforeRedirect(url, category, event, details) {
    window.superadmin ? sendSuperadmin(category, event, details) : send(category, event, details);

    window.location.href = url;
}

function buildUserParams(user, includePermissions = false) {
    const params = {
        identityId: user.id,
        name: user.user.data.name,
        surname: user.user.data.surname,
        username: user.user.data.username,
    }

    if (includePermissions && user.permissions && user.permissions.data) {
        params.permissions = user.permissions.data;
    }

    return params;
}

export default {
    send,
    sendSchoolAdminEvent: send.bind(null, 'School Admin'),
    sendLoginEvent: send.bind(null, 'Login'),
    sendPollFillingEvent: send.bind(null, 'Poll-filling'),
    sendResultsEvent: send.bind(null, 'Results'),
    sendResultsPdfEvent: send.bind(null, 'Results PDF modal'),
    sendResultsExcelEvent: send.bind(null, 'Results Excel Manual modal'),
    sendSurveyBuilderEvent: send.bind(null, 'Survey builder'),
    sendOnboardingEvent: send.bind(null, 'Onboarding'),
    sendSuperadminEvent: sendSuperadmin.bind(null, 'Superadmin'),
    sendFreemiumEvent: send.bind(null, 'Freemium'),

    downloadCSV,
    trackSuperadminRedirects,
    handleEventBeforeRedirect,
    buildUserParams,
    settings,
    ga // export google analytics service as well
}
